import React from "react"
import Card from "../../newComponents/card";
import SectionListing from "../../newComponents/sectionListing";

const relatedGalleries = ({ block }) => (
  <SectionListing title={block.headline} primaryBackground={true}>
      {block.relatedGalleries.map((item, i) => (
        <Card key={item.displayTitle} image={item.featureImage[0]} title={item.displayTitle} href={`/${item.uri}`}/>
      ))}
  </SectionListing>
)

export default relatedGalleries;